// extracted by mini-css-extract-plugin
module.exports = {"dirRtl":"layout_dirRtl__BffS7","dirLtr":"layout_dirLtr__4V4Io"};